export default {
      id: "ce-usage",
      viewBox: "0 0 49 35",
      url: __webpack_public_path__ + "sprite.svg#ce",
      toString: function () {
        return this.url;
      }
    }